module.exports = __webpack_public_path__ + "img/tf2_killstreakkit_standard.469aad0b.png";